import { DateTime } from 'luxon'

export function getNow(zone = 'UTC') {
  return DateTime.utc().setZone(zone)
}
